export const extensionUids = ['raffle', 'hiddenObject'];

export const toFavoriteQuest = 'toFavoriteQuest';
export const toBasketQuest = 'toBasketQuest';
export const toFavoriteRoutineQuest = 'toFavoriteRoutineQuest';
export const toBasketRoutineQuest = 'toBasketRoutineQuest';

export const tasksForSavingProductsToGA = {
  [toFavoriteQuest]: 'favoriteQuest',
  [toBasketQuest]: 'basketQuest',
  [toFavoriteRoutineQuest]: 'favoriteQuest',
  [toBasketRoutineQuest]: 'basketQuest',
};

export const tasksWithInternalLink = {
  toFavoriteQuest: 'favoriteQuest',
  toBasketQuest: 'basketQuest',
  toHiddenObject: 'hiddenObject',
  toInternalLink: 'internalQuest',
};

export const REFERRAL_TRIGGER_WORD = {
  shadowReferral: 'статье',
  salesReferral: 'разделе',
  teensReferral: 'разделе',
  candlesReferral: 'статье',
  decorReferral: 'статье',
  waterReferral: 'описании продукта',
  tgTeensReferral: 'телеграм-канале',
  aromaReferral: 'Квентин Биш',
  productDescriptionReferral: 'описании продукта',
  laboratoryReferral: 'Бьюти-лаборатория',
};

export const COMPLETED_PROFILE = 'completedProfile';
